var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSofa6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 2C4.34315 2 3 3.34315 3 5V8.64494C3.31685 8.55064 3.65251 8.5 4 8.5C5.933 8.5 7.5 10.067 7.5 12V13C7.5 13.8284 8.17157 14.5 9 14.5H11.25V2H6Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21 5V8.64494C20.6831 8.55064 20.3475 8.5 20 8.5C18.067 8.5 16.5 10.067 16.5 12V13C16.5 13.8284 15.8284 14.5 15 14.5H12.75V2H18C19.6569 2 21 3.34315 21 5Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20 10C21.1046 10 22 10.8954 22 12V14C22 15.8948 21.1217 17.5844 19.75 18.684V22C19.75 22.4142 19.4142 22.75 19 22.75C18.5858 22.75 18.25 22.4142 18.25 22V19.5639C17.5552 19.8451 16.7957 20 16 20H8C7.20432 20 6.44482 19.8451 5.75 19.5639V22C5.75 22.4142 5.41421 22.75 5 22.75C4.58579 22.75 4.25 22.4142 4.25 22V18.684C2.87831 17.5844 2 15.8948 2 14V12C2 10.8954 2.89543 10 4 10C5.10457 10 6 10.8954 6 12V13C6 14.6569 7.34315 16 9 16H15C16.6569 16 18 14.6569 18 13V12C18 10.8954 18.8954 10 20 10Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSofa6);
export default __webpack_public_path__ + "static/media/sofa-6.a67489575900391e58f1e2401f1aecc5.svg";
export { ForwardRef as ReactComponent };